$(document).ready(function () {
  $(".btn1").click(function () {
    $("#myModal1").modal("show");
  });

  $(".btn2").click(function () {
    $("#myModal2").modal("show");
  });

  $(".btn3").click(function () {
    $("#myModal3").modal("show");
  });

  $(".btn4").click(function () {
    $("#myModal4").modal("show");
  });

  $(".video-section-school-gym").slick({
    dots: true,
    arrows: true,
    infinite: false,
    prevArrow: '<i class="fas fa-chevron-left"></i>',
    nextArrow: '<i class="fas fa-chevron-right"></i>',
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  /*  $('.video-section-school-gym').slick({
  dots: true,
    infinite:false,
    arrows: true,
    prevArrow: '<i class="fas fa-chevron-left"></i>',
    nextArrow: '<i class="fas fa-chevron-right"></i>',
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    
  ]
}); */

  $(".video-section-performance").slick({
    dots: true,
    arrows: true,
    infinite: false,
    prevArrow: '<i class="fas fa-chevron-left"></i>',
    nextArrow: '<i class="fas fa-chevron-right"></i>',
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".video-section-functional").slick({
    dots: true,
    arrows: true,
    infinite: false,
    prevArrow: '<i class="fas fa-chevron-left"></i>',
    nextArrow: '<i class="fas fa-chevron-right"></i>',
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".video-section-home").slick({
    dots: true,
    arrows: true,
    infinite: false,
    prevArrow: '<i class="fas fa-chevron-left"></i>',
    nextArrow: '<i class="fas fa-chevron-right"></i>',
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // add all to same gallery
  $(".performance-slider-one a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".performance-slider-one a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".performance-slider-one a").fancybox();

  // add all to same gallery
  $(".performance-slider-two a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".performance-slider-two a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".performance-slider-two a").fancybox();

  // add all to same gallery
  $(".performance-slider-three a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".performance-slider-three a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".performance-slider-three a").fancybox();

  // add all to same gallery
  $(".performance-slider-four a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".performance-slider-four a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".performance-slider-four a").fancybox();

  // add all to same gallery
  $(".performance-slider-five a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".performance-slider-five a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".performance-slider-five a").fancybox();

  // add all to same gallery
  $(".performance-slider-six a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".performance-slider-six a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".performance-slider-six a").fancybox();

  // add all to same gallery
  $(".performance-slider-seven a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".performance-slider-seven a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".performance-slider-seven a").fancybox();

  // add all to same gallery
  $(".performance-slider-eight a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".performance-slider-eight a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".performance-slider-eight a").fancybox();

  // add all to same gallery
  $(".performance-slider-nine a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".performance-slider-nine a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".performance-slider-nine a").fancybox();

  // add all to same gallery
  $(".performance-slider-ten a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".performance-slider-ten a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".performance-slider-ten a").fancybox();

  // add all to same gallery
  $(".performance-slider-eleven a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".performance-slider-eleven a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".performance-slider-eleven a").fancybox();

  $(".performance-slider-tewlav a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".performance-slider-tewlav a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".performance-slider-tewlav a").fancybox();

  $(".performance-slider-thirteen a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".performance-slider-thirteen a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".performance-slider-thirteen a").fancybox();

  // add all to same gallery
  $(".school-gym-slider-one a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".school-gym-slider-one a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".school-gym-slider-one a").fancybox();

  // add all to same gallery
  $(".school-gym-slider-two a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".school-gym-slider-two a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".school-gym-slider-two a").fancybox();

  // add all to same gallery
  $(".school-gym-slider-three a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".school-gym-slider-three a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".school-gym-slider-three a").fancybox();

  // add all to same gallery
  $(".school-gym-slider-four a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".school-gym-slider-four a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".school-gym-slider-four a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-a a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-a a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-a a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-b a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-b a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-b a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-c a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-c a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-c a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-d a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-d a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-d a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-e a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-e a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-e a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-f a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-f a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-f a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-g a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-g a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-g a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-h a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-h a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-h a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-i a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-i a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-i a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-j a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-j a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-j a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-dd a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-dd a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-dd a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-ee a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-ee a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-ee a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-k a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-k a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-k a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-l a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-l a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-l a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-m a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-m a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-m a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-n a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-n a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-n a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-o a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-o a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-o a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-p a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-p a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-p a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-q a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-q a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-q a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-r a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-r a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-r a").fancybox();

  // add all to same gallery
  $(".video-section-functional-slider-s a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-functional-slider-s a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-functional-slider-s a").fancybox();

  /*------ Home gym Gallery Js ----------*/
  // add all to same gallery
  $(".video-section-home-slider-a a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-home-slider-a a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-home-slider-a a").fancybox();

  // add all to same gallery
  $(".video-section-home-slider-b a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-home-slider-b a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-home-slider-b a").fancybox();

  // add all to same gallery
  $(".video-section-home-slider-c a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-home-slider-c a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-home-slider-c a").fancybox();

  // add all to same gallery
  $(".video-section-home-slider-d a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-home-slider-d a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-home-slider-d a").fancybox();

  // add all to same gallery
  $(".video-section-home-slider-e a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-home-slider-e a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-home-slider-e a").fancybox();

  // add all to same gallery
  $(".video-section-home-slider-f a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-home-slider-f a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-home-slider-f a").fancybox();

  // add all to same gallery
  $(".video-section-home-slider-g a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-home-slider-g a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-home-slider-g a").fancybox();

  // add all to same gallery
  $(".video-section-home-slider-h a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-home-slider-h a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-home-slider-h a").fancybox();

  // add all to same gallery
  $(".video-section-home-slider-i a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-home-slider-i a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-home-slider-i a").fancybox();

  // add all to same gallery
  $(".video-section-home-slider-j a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-home-slider-j a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-home-slider-j a").fancybox();

  // add all to same gallery
  $(".video-section-home-slider-k a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-home-slider-k a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-home-slider-k a").fancybox();

  // add all to same gallery
  $(".video-section-home-slider-l a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-home-slider-l a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-home-slider-l a").fancybox();

  // add all to same gallery
  $(".video-section-home-slider-m a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-home-slider-m a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-home-slider-m a").fancybox();

  // add all to same gallery
  $(".video-section-home-slider-n a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-home-slider-n a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-home-slider-n a").fancybox();

  // add all to same gallery
  $(".video-section-home-slider-o a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-home-slider-o a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".video-section-home-slider-o a").fancybox();

  // add all to same gallery
  $(".video-section-home-slider-r a").attr("data-fancybox", "mygallery");
  // assign captions and title from alt-attributes of images:
  $(".video-section-home-slider-r a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });

  // start fancybox:
  $(".video-section-home-slider-r a").fancybox();

  $(".set > a").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".content").slideUp(200);
      $(".set > a i").removeClass("fa-minus").addClass("fa-plus");
    } else {
      $(".set > a i").removeClass("fa-minus").addClass("fa-plus");
      $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this).siblings(".content").slideDown(200);
    }
  });

  $(".fancybox-thumbs__list a").each(function () {
    var bal = jQuery(this).attr("data-index");

    console.log(bal);

    if (parseInt(bal) > 14) {
      jQuery(this).remove();
    }
  });

  jQuery(".site-nav__link--icon").click(function () {
    jQuery(".mobile-nav__link--top-level")
      .next()
      .find("button")
      .trigger("click");
  });

  $(".return_accordian > a").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".content").slideUp(200);
      $(".return_accordian > a i").removeClass("fa-minus").addClass("fa-plus");
    } else {
      $(".return_accordian > a i").removeClass("fa-minus").addClass("fa-plus");
      $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      $(".return_accordian > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this).siblings(".content").slideDown(200);
    }
  });

  $(".return_form > a").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".content").slideUp(200);
      $(".return_form > a i").removeClass("fa-minus").addClass("fa-plus");
    } else {
      $(".return_form > a i").removeClass("fa-minus").addClass("fa-plus");
      $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      $(".return_form > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this).siblings(".content").slideDown(200);
    }
  });

  $(".cart__checkout-wrapper").click(function () {
    $(this).addClass("show-loader");
  });

  $(".tt-wrapper.product-information-buttons a").click(function () {
    $(".modal.fade").addClass("intro");
  });
  $("button.close").click(function () {
    $(".modal.fade").removeClass("intro");
  });

  setTimeout(function () {
    if (
      $(
        ".product-single__meta .product-block > .product-block input#preOrderButton"
      ).hasClass("preOrderButton")
    ) {
      $(".product-block.product-block--sales-point ul li#false").css(
        "display",
        "none"
      );
    }
  }, 2000);
});

$(document).ready(function () {
  // Remove the "rte__image" class from all anchor elements with the class "custm_img"
  $(".custm_img a").removeClass("rte__image");
});
